import { render, staticRenderFns } from "./IcoHome.vue?vue&type=template&id=fec368ba&"
import script from "./IcoHome.vue?vue&type=script&lang=js&"
export * from "./IcoHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports